// extracted by mini-css-extract-plugin
export default {"tag":"_5UTmnXKPa-4yqXuxJ1Gc8w=="};